var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.94 7.447A7.447 7.447 0 0 0 26.493 0H7.447A7.447 7.447 0 0 0 0 7.447v8.86a7.447 7.447 0 0 0 7.447 7.447h19.046a7.447 7.447 0 0 0 7.447-7.447v-8.86Zm-11.2 5.095-8.54 4.223c-.333.183-1.471-.062-1.471-.44V7.651c0-.386 1.147-.626 1.48-.435l8.176 4.446c.342.195.702.689.356.88Z",
    fill: "#4F4F4F"
  })));
};

export default SvgYoutube;